module.exports = __webpack_public_path__ + "img/Cardnoise.3046c3c8.png";